// Schlussformel im Brief/E-Mail-Text (#586): die letzte Zeile, die nur aus einer Grußformel besteht („Mit freundlichen
// Grüßen“, „Hochachtungsvoll“ …), bis zum Ende ist der Schluss. Er wird durch die Grußformel des Absenders ersetzt.

const SCHLUSS = /^\s*(?:(?:mit\s+)?(?:freundlichen|besten|herzlichen|lieben|vielen?|beste|freundliche|liebe|herzliche)\s+gr(?:ü|ue)(?:ß|ss)(?:en|e)|hochachtungsvoll)\s*[,!.]?\s*$/i;

/** Zeichenposition, ab der der Schluss beginnt – null, wenn es keine Gruß-Zeile gibt. */
export function schlussAb(text: string): number | null {
  const zeilen = text.split('\n');
  let pos = 0, treffer: number | null = null;
  for (const z of zeilen) { if (SCHLUSS.test(z)) treffer = pos; pos += z.length + 1; }
  return treffer;
}

/** Schluss der Vorlage durch die eigene Grußformel ersetzen (ohne Schluss: anhängen). Leer = unverändert. */
export function mitGrussformel(text: string, grussformel: string | null | undefined): string {
  const g = (grussformel ?? '').trim();
  if (!g) return text;
  const ab = schlussAb(text);
  return ab === null ? `${text.trimEnd()}\n\n${g}` : `${text.slice(0, ab)}${g}`;
}
